import { NavLink, useNavigate, Outlet } from "react-router-dom";
import { LayoutDashboard, Users, LogOut, ShieldCheck } from "lucide-react";
import { useAuth } from "./AuthContext";

export default function PortalLayout() {
  const { user, logout } = useAuth();
  const navigate = useNavigate();

  const handleLogout = () => {
    logout();
    navigate("/portal");
  };

  const linkClasses = ({ isActive }) =>
    `flex items-center gap-3 px-4 py-3 text-xs tracking-[0.2em] uppercase transition-colors ${
      isActive
        ? "bg-[#121215] text-[#D4AF37] border-l-2 border-[#D4AF37]"
        : "text-neutral-400 hover:text-neutral-100 border-l-2 border-transparent"
    }`;

  return (
    <div className="min-h-screen bg-[#08080A] text-neutral-100 flex" data-testid="portal-layout">
      {/* Sidebar */}
      <aside className="w-64 shrink-0 border-r border-white/8 bg-[#0A0A0D] flex flex-col">
        <div className="p-6 border-b border-white/8">
          <div className="flex items-center gap-3">
            <img
              src="/crest.png"
              alt="Rudra Empire"
              className="h-11 w-auto shrink-0"
            />
            <div>
              <div className="font-display text-sm tracking-[0.2em] text-neutral-100">RUDRA EMPIRE</div>
              <div className="text-[0.6rem] tracking-[0.24em] uppercase text-[#D4AF37] mt-0.5">
                Portal
              </div>
            </div>
          </div>
        </div>

        <nav className="flex-1 py-4 flex flex-col gap-1">
          <NavLink data-testid="nav-dashboard" to="/portal/dashboard" className={linkClasses}>
            <LayoutDashboard strokeWidth={1.2} className="w-4 h-4" />
            Dashboard
          </NavLink>
          {user?.role === "admin" && (
            <NavLink data-testid="nav-team" to="/portal/team" className={linkClasses}>
              <Users strokeWidth={1.2} className="w-4 h-4" />
              Team
            </NavLink>
          )}
        </nav>

        <div className="p-4 border-t border-white/8">
          <div className="mb-4 p-3 border border-white/8">
            <div className="flex items-center gap-2">
              {user?.role === "admin" && (
                <ShieldCheck strokeWidth={1.3} className="w-4 h-4 text-[#D4AF37]" />
              )}
              <div className="text-sm text-neutral-100 truncate">{user?.name}</div>
            </div>
            <div className="text-[0.65rem] tracking-widest uppercase text-neutral-500 mt-1">
              {user?.role}
            </div>
            <div className="text-xs text-neutral-500 truncate mt-1">{user?.email}</div>
          </div>
          <button
            data-testid="portal-logout-btn"
            onClick={handleLogout}
            className="w-full flex items-center gap-3 px-3 py-2.5 border border-white/10 text-neutral-400 hover:text-[#D4AF37] hover:border-[#D4AF37]/50 text-[0.68rem] tracking-[0.24em] uppercase transition-colors"
          >
            <LogOut strokeWidth={1.2} className="w-4 h-4" />
            Sign out
          </button>
        </div>
      </aside>

      {/* Main */}
      <main className="flex-1 overflow-x-hidden">
        <Outlet />
      </main>
    </div>
  );
}
